import { render, staticRenderFns } from "./permissionSelect.vue?vue&type=template&id=1a279d44&"
import script from "./permissionSelect.vue?vue&type=script&lang=js&"
export * from "./permissionSelect.vue?vue&type=script&lang=js&"
import style0 from "./permissionSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports